import { useCSSVariable } from 'uniwind';

/**
 * The presence palette resolved to concrete colors for the active theme.
 * Eight static hook calls (rules of hooks — the count must not vary) matching
 * PALETTE_SIZE and the --color-presence-* tokens in global.css.
 */
export function usePresencePalette(): string[] {
  const resolved = [
    useCSSVariable('--color-presence-0'),
    useCSSVariable('--color-presence-1'),
    useCSSVariable('--color-presence-2'),
    useCSSVariable('--color-presence-3'),
    useCSSVariable('--color-presence-4'),
    useCSSVariable('--color-presence-5'),
    useCSSVariable('--color-presence-6'),
    useCSSVariable('--color-presence-7'),
  ];
  return resolved.map((c) => (typeof c === 'string' ? c : '#888888'));
}
